<template>
  <div class="sky__search-wrapper small relative" style="width: 400px;">
    <input
      v-model="search"
      class="sky__search-input focus:outline-none bg-sky_grey_darker px-4 small text-xs"
      name="skylantern__search"
      type="text"
      :placeholder="placeholder"
      @input="makeSearch"
      @keyup.enter="enterWasPressed"
      @keyup.down="downWasPressed"
      @keyup.up="upWasPressed"
      @focus="search && search.length ? makeSearch() : undefined"
      @blur="onBlur"
      v-on="listeners"
    >
    <transition name="bounce">
      <div v-if="result" class="absolute z-10 overflow-auto shadow-2xl rounded border-sky_secondary border-2" style="top: 120%; left: 0; right: 0; height: 300px;background: white;">
        <div v-for="(item, itemIndex) in result.hits" :key="item.sku" @click="$router.push($helpers.makeUri(item.path))">
          <div class="p-2 flex cursor-pointer hover:bg-sky_grey_darker" :class="selectedIndex === itemIndex ? 'bg-sky_grey_darker' : ''">
            <div style="width: 50px; height: 50px" class="flex-shrink-0">
              <img :src="`${item.cover}?format=webp&resize=true&width=50&height=50`" :alt="item.label">
            </div>
            <div class="ml-2">
              <div class="text-xs flex-grow">
                {{ item.label }}
              </div>
              <div class="text-xs text-sky_grey">
                #{{ item.sku }}
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import omit from 'lodash.omit'
import algoliasearch from 'algoliasearch/lite'
const client = algoliasearch('GS18F5F1NL', '4667e1a6962d23cb13aab5af604ed12c')
const index = client.initIndex('products')

export default {
  props: {
    placeholder: {
      required: false,
      default: 'Néon, Mariage, Bohême',
      type: String
    },
    slug: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      result: null,
      search: '',
      queued: false,
      searching: false,
      selectedIndex: 0
    }
  },
  computed: {
    listeners () {
      return omit(this.$listeners, ['input'])
    }
  },
  methods: {
    async makeSearch () {
      this.selectedIndex = 0
      if (this.searching) {
        this.queued = true
        return
      }
      this.searching = true
      const response = await index.search(this.search, {
        hitsPerPage: 50,
        filters: 'path:"' + this.slug + '"'
      })
      this.result = response
      this.searching = false
      if (this.queued) {
        this.queued = false
        await this.makeSearch()
      }
    },
    enterWasPressed () {
      if (this.result && this.result.hits[this.selectedIndex]) {
        this.$router.push(this.$helpers.makeUri(this.result.hits[this.selectedIndex].path))
      }
    },
    downWasPressed () {
      if (!this.result || this.selectedIndex === this.result.hits.length - 1) {
        return
      }
      this.selectedIndex++
    },
    upWasPressed () {
      if (!this.result || this.selectedIndex === 0) {
        return
      }
      this.selectedIndex--
    },
    onBlur () {
      setTimeout(() => {
        this.result = null
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__search-input {
  width: 100%;
  border-radius: 50px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 45px;
  &.small {
    height: 40px;
  }
}

.sky__search-wrapper {
  position: relative;
  height: 45px;
  &.small {
    height: 40px;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 7px;
    top: 0;
    width: 47px;
    height: 47px;
    background-image: url(../../assets/icons/interface-search.svg?img);
    background-size: cover;
    z-index: 50;
  }
  &.small {
    &::after {
      transform: scale(0.8);
      top: -4px
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.bounce-leave-active {
  animation: bounce-in .2s reverse;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
